import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormControlComponent, DynamicFormControlCustomEvent, DynamicFormLayoutService, DynamicFormValidationService } from '@ng-dynamic-forms/core';
import { BtTextareaModel } from './bt-textarea.model';

@Component({
  selector: 'dynamic-bt-textarea',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-bt-textarea.component.html'
})
export class DynamicBtTextareaComponent extends DynamicFormControlComponent {
  @Input() bindId = true;
  @Input() override group: FormGroup;
  @Input() override model: BtTextareaModel;
  @Output() override blur: EventEmitter<any> = new EventEmitter();
  @Output() override change: EventEmitter<any> = new EventEmitter();
  @Output() override customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() override focus: EventEmitter<any> = new EventEmitter();
  constructor(protected override layoutService: DynamicFormLayoutService, protected override validationService: DynamicFormValidationService) {
    super(layoutService, validationService);
  }
}
